module.exports = __webpack_public_path__ + "img/06.ce7c6936.jpg";